import { billDraftingActions } from '../actions/billDraftingAction';

const initialState = {
  titles: null,
  titleContent: [],
  sectionContent: null,
  adminText: null,
  isLoading: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case billDraftingActions.STORE_TITLES:
      return { ...state, titles: action.titles };

    case billDraftingActions.STORE_TITLE_CONTENT:
      return { ...state, titleContent: action.titleContent };

    case billDraftingActions.STORE_TEXT_CONTENT:
      return { ...state, sectionContent: action.text };

    case billDraftingActions.LOADING_CONTENT:
      return { ...state, isLoading: action.status };

    default:
      return state;
  }
}
